import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchJob } from "@/lib/api";
import { activeJob, clearActive, isActive } from "@/lib/jobs";

/**
 * One quiet line under the top bar on every page while this browser has a training under way
 * (Dog 2026-08-29: progress persists through navigation until the pipeline finishes).
 * 2026-10-27: an unpaid checkout no longer counts — it used to hold this line for a month.
 */
export default function LiveJobStrip() {
  const [job, setJob] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      const id = activeJob();
      if (!id) { setJob(null); return; }
      try {
        const j = await fetchJob(id);
        if (!alive) return;
        if (isActive(j)) setJob(j);
        else { clearActive(id); setJob(null); }
      } catch (e) {
        if (alive && e?.response?.status === 404) { clearActive(id); setJob(null); }
      }
    };
    poll();
    const iv = setInterval(poll, 8000);
    return () => { alive = false; clearInterval(iv); };
  }, [pathname]);

  if (!job || pathname === `/progress/${job.job_id}`) return null;

  return (
    <>
    {/* holds the strip's height in the page so nothing slides under it */}
    <div aria-hidden className="h-11" />
    <div data-testid="live-job-strip" className="ex-strip">
      <Link to={`/progress/${job.job_id}`} className="ex-wrap h-11 flex items-center gap-3 text-[13px]">
        <span className="ex-dot ex-dot-live" />
        <span className="text-white truncate">Training · {job.subject}</span>
        <span className="hidden sm:inline truncate ex-dim">{job.progress}</span>
        <span className="ml-auto shrink-0 inline-flex items-center gap-1 text-white">
          View <ArrowRight className="h-3.5 w-3.5" strokeWidth={1.8} />
        </span>
      </Link>
    </div>
    </>
  );
}
